import { SearchGroup } from '@components/input';
import { IFilterSelectItems } from '@redux/slices/order';
import { Col, Row } from 'antd';
import React, { memo, useContext } from 'react';
import { ExportButton } from '@styles/components/button';
import { useDispatch } from 'react-redux';
import { ModalContext } from 'src/contexts/modal-context';
import { EditDelegationModal } from './edit-modal';
import { filterDelegation } from '@redux/slices/delegation';
import { translate } from '@components/i18n';

export const Header: React.FC = memo(() => {
    const dispatch = useDispatch();
    const modalContext = useContext(ModalContext);

    const filter = (filter: Partial<IFilterSelectItems>): void => {
        dispatch(filterDelegation(filter.filterValue));
    };

    const addMarketing = (): void => {
        modalContext.setIsOpen(true, <EditDelegationModal />, {
            title: translate('general.addNewDelegation'),
            width: '40%',
        });
    };

    return (
        <Col>
            <Row style={{ marginTop: 20 }} align="middle">
                <Col span={24}>
                    <Row justify={'space-between'} align="middle">
                        <Col span={10}>
                            <SearchGroup
                                onBlur={(e) =>
                                    filter({ filterValue: e.target.value })
                                }
                                allowClear
                                placeholder={translate(
                                    'forms.placeholders.searchForReason',
                                )}
                                onSearch={(e) => {
                                    filter({ filterValue: e });
                                }}
                                onChange={(e) => {
                                    filter({ filterValue: e.target.value });
                                }}
                            />
                        </Col>
                        <Col span={14}>
                            <Row justify={'end'}>
                                <Col span={12}></Col>
                                {/* <Col span={5} style={{ marginRight: 10 }}>
                                    <ExportButton
                                        onClick={() => {
                                            alert('Em pesquisa');
                                        }}
                                    >
                                        Exportar <DownloadOutlined />
                                    </ExportButton>
                                </Col> */}
                                <Col span={5} style={{ marginRight: 10 }}>
                                    <ExportButton onClick={addMarketing}>
                                        {translate('forms.buttons.addNew')}
                                    </ExportButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
});
